import React from 'react';

interface IconWrapperProps {
  Icon: React.ComponentType<any>;
  HoverIcon: React.ComponentType<any>;
  isActive?: boolean;
  size?: number;
  color?: string;
  className?: string;
}

/**
 * IconWrapper - A generic component that handles icon hover and active states
 * @param Icon - The default icon component
 * @param HoverIcon - The icon component to show on hover or when active
 * @param isActive - Whether the icon should be in active state
 * @param size - Size of the icon (passed to both Icon components)
 * @param color - Color of the icon (passed to both Icon components)
 * @param className - Additional className for the wrapper
 */
const IconWrapper: React.FC<IconWrapperProps> = ({ Icon, HoverIcon, isActive = false, size = 24, color = 'currentColor', className = '' }) => (
  <div className={`relative w-${size} h-${size} ${className}`}>
    <Icon size={size} color={color} className={`absolute top-0 left-0 ${isActive ? 'opacity-0' : 'group-hover:opacity-0'}`} />
    <HoverIcon size={size} color={color} className={`absolute top-0 left-0 ${isActive ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`} />
  </div>
);

export default IconWrapper;
